import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Login.css';
import './ResetPassword.css';

import gox from '../../assets/gox.png';

function ResetPassword() {
  const [passwordVisible, setPasswordVisible] = useState(false);

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <>
      <div className='banner d-flex'>
        <div className="left px-5 py-5">
          <div className='pb-5'> <h6>GOX Register</h6></div>
          <div>
            <div className='pt-5 pb-5'>
              <h1> Where finance <br /> meets management.</h1>
              <p>Lorem ipsum dolor sit amet consectetur. Lectus nulla sit interdum
                et feugiat odio. Lorem ipsum dolor sit amet consectetur. Lectus nulla sit
                interdum et feugiat odio.
              </p>
            </div>

            <div className='dynamic p-3'>
              <p>
                In the dynamic landscape of modern workplaces, HR stands as the guardian of culture and the champion of employee well-being. We see our mission as not just managing resources, but as stewards of an environment
                where each person's unique skills and perspectives are valued.
              </p>
              <div className='d-flex mt-5 '>
                <div className='mx-2'><img src={gox} alt="logo" /></div>
                <div>
                  <h6>Gox register</h6>
                  <p>Our mission</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          {/* Right Column with back-button */}
          <Link to="/Forgotpassword"> 
            {/* Add the appropriate route for Back button */}
            <button className="back-button">Back</button>
          </Link>
        </div>

        <div className="container forms">
          <div className="row">
            {/* Left Column with H1 and P Tag */}
            <div className="welcome col-md-6 col-sm-12">
              <h1>Reset Password?</h1>
              <p> Enter your new password for your account and confirm the
                password to successfully reset.
              </p>
            </div>

            {/* Password fields and confirmation code input here */}
            <div className="col-md-6 col-sm-12">
              <form>
                <div className="mb-3">
                  <label htmlFor="newPassword" className="form-label">
                    Enter New Password
                  </label>
                  <div className="input-with-icon"> {/* Container for input and icon */}
                    <input type={passwordVisible ? "text" : "password"} className="form-control" id="newPassword" placeholder="Enter new password" />
                    <i className="fa fa-eye" id="togglePassword" onClick={togglePasswordVisibility}></i> {/* Toggle password visibility */}
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="form-label"> 
                    Confirm Password
                  </label>
                  <div className="input-with-icon"> {/* Container for input and icon */}
                    <input type={passwordVisible ? "text" : "password"} className="form-control" id="confirmPassword" placeholder="Confirm password"/>
                    <i className="fa fa-eye" id="togglePassword" onClick={togglePasswordVisibility}></i> {/* Toggle password visibility */}
                  </div>
                </div>

                <Link to="/">
                  <button type="submit" className="btn btn1 w-100">Complete reset</button>
                </Link>
              </form>
            </div>
          </div>

          <div>  
            <div className="mt-3">
              <p>Need help? <a href="#">Contact Support</a></p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ResetPassword;